{
  document.querySelectorAll('button.favorites--remove-all').forEach(button => {
    button.addEventListener('click', e => {
      if(confirm("Are you sure you want to remove all your favorites? This action cannot be undone.")){
        window.coolHelperFunctions.setCookie('favorites', '', -1);
        window.location.reload()
      }
    })
  })
}